<div class="settings-container max-w-3xl mx-auto py-4">
  <p-card styleClass="mb-4 shadow-1 border-none">
    <div class="px-2">
      <h3 class="text-900 font-bold mb-4 flex align-items-center gap-2">
        <i class="pi pi-palette text-primary"></i>
        Apariencia
      </h3>
      <div class="flex justify-content-between align-items-center">
        <div class="flex flex-column gap-1">
          <span class="font-semibold text-800">Modo Oscuro</span>
          <span class="text-500 text-sm">Cambia el aspecto visual de la aplicación</span>
        </div>
        <p-inputSwitch [(ngModel)]="darkMode" (ngModelChange)="themeService.toggleTheme()"></p-inputSwitch>
      </div>
    </div>
  </p-card>

  <p-card styleClass="mb-4 shadow-1 border-none">
    <div class="px-2">
      <h3 class="text-900 font-bold mb-4 flex align-items-center gap-2">
        <i class="pi pi-user text-primary"></i>
        Cuenta y Perfil
      </h3>

      <div
        class="flex justify-content-between align-items-center cursor-pointer hover:surface-100 p-2 border-round transition-duration-150"
        (click)="showProfileDialog()">
        <div class="flex flex-column gap-1">
          <span class="font-semibold text-800">Mi Perfil</span>
          <span class="text-500 text-sm">Gestiona tu información personal y avatar</span>
        </div>
        <i class="pi pi-chevron-right text-400"></i>
      </div>

      <p-divider></p-divider>

      <div
        class="flex justify-content-between align-items-center cursor-pointer hover:surface-100 p-2 border-round transition-duration-150"
        (click)="visibleSecurity = true">
        <div class="flex flex-column gap-1">
          <span class="font-semibold text-800">Seguridad</span>
          <span class="text-500 text-sm">Actualiza tu contraseña de acceso</span>
        </div>
        <i class="pi pi-lock text-400"></i>
      </div>
    </div>
  </p-card>

  <p-card styleClass="shadow-1 border-none">
    <div class="px-2">
      <h3 class="text-900 font-bold mb-4 flex align-items-center gap-2">
        <i class="pi pi-sign-out text-primary"></i>
        Sesión
      </h3>
      <div
        class="flex justify-content-between align-items-center cursor-pointer hover:surface-100 p-2 border-round transition-duration-150"
        (click)="logout()">
        <div class="flex flex-column gap-1">
          <span class="font-bold text-800">Finalizar Sesión</span>
          <span class="text-500 text-sm">Salir de la cuenta de forma segura</span>
        </div>
        <i class="pi pi-sign-out text-400"></i>
      </div>
    </div>
  </p-card>
</div>

<p-confirmDialog appendTo="body"></p-confirmDialog>

<!-- Profile Edit Dialog -->
<p-dialog [(visible)]="visibleProfile" header="Editar Perfil" [modal]="true" [style]="{width: '450px'}"
  styleClass="p-fluid" appendTo="body">
  <form [formGroup]="formProfile" (ngSubmit)="editProfile()" class="mt-4">
    <div class="field mb-4">
      <app-input name="username" formControlName="username" label="Nombre de usuario" type="text" />
    </div>
    <div class="field mb-4">
      <app-input name="email" formControlName="email" label="Correo electrónico" type="email" />
    </div>
    <div class="field mb-4">
      <app-input name="phone" formControlName="phone" label="Teléfono" type="text" />
    </div>

    <div class="flex justify-content-end gap-2 mt-4">
      <p-button label="Cancelar" icon="pi pi-times" [text]="true" (onClick)="visibleProfile = false" />
      <p-button label="Guardar Cambios" icon="pi pi-check" [loading]="isSavingProfile" type="submit"
        [disabled]="formProfile.invalid" />
    </div>
  </form>
</p-dialog>

<!-- Security Change Password Dialog -->
<p-dialog header="Cambiar Contraseña" [modal]="true" [(visible)]="visibleSecurity" [style]="{ width: '450px' }"
  styleClass="p-fluid" appendTo="body" (onHide)="visibleSecurity = false">
  <div class="mt-4">
    <app-change-password #changePasswordForm />
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Cancelar" severity="secondary" [text]="true" icon="pi pi-times"
      (onClick)="visibleSecurity = false" />
    <p-button label="Actualizar Contraseña" icon="pi pi-check" (onClick)="onSubmitChangePassword(changePasswordForm)" />
  </ng-template>
</p-dialog>